export default "__VITE_ASSET__X5nM1tZR__"